import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { stylesConstants } from '../../styles/stylesConstants';

export default makeStyles((theme: Theme) => ({
  content: {
    width: `calc(100vw - ${stylesConstants.sideMenuWidth}px)`,
    height: `calc(100vh - ${stylesConstants.headerHeight}px)`,
    overflow: 'scroll',
  },
  notHeader: { width: '100vw', display: 'flex', flexDirection: 'row' },
}));
